/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type representing the button component type in a WhatsApp template
 */
export enum WhatsAppTemplateButtonComponentType {
    BUTTON = 'button',
    BUTTONS = 'buttons',
}
